import { render } from "./KeyC.vue?vue&type=template&id=2186086c"
import script from "./KeyC.vue?vue&type=script&lang=ts"
export * from "./KeyC.vue?vue&type=script&lang=ts"
script.render = render

export default script